// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"page-wrapper_pageWrapper__1SCa0"};